import { gql } from '@apollo/client';

const schema = {
  get: {
    name: 'brand',
    serviceName: 'graphql',
    query: gql`
      query brand($ids: [String]) {
        brand(ids: $ids) {
          data {
            id
            title
            media {
              id
              full_url
            }
          }
        }
      }
    `,
  },
};

export default schema;
